<template>
  <rabbey-top-menu />
</template>

<script>
export default {
  name: "Manager"
};
</script>
